import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0377e31f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "form-dropdown__icon",
  width: "16",
  height: "9",
  viewBox: "0 0 16 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.34317 0L0.928955 1.41421L8.00001 8.48531L15.0711 1.41424L13.6569 2.90871e-05L8.00003 5.65686L2.34317 0Z",
    fill: "#C6A9E3",
    "fill-opacity": "0.65"
  })
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  disabled: "",
  selected: ""
}
const _hoisted_6 = ["value"]

import { useStore } from 'vuex';
import { computed, ref, Ref, watch } from 'vue';

export interface ChangeValueEventInterface {
  index: string | null;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    defaultIndex: null,
    modelValue: null,
    defaultValue: null,
    placeholder: null,
    readonly: null,
    isError: null,
    targetHost: null
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', params: ChangeValueEventInterface): void;
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: number[] | string[] | { [key: string]: string | number };
  defaultIndex?: number;
  modelValue?: string;
  defaultValue?: string;
  placeholder?: string;
  readonly?: boolean;
  isError?: boolean;
  targetHost?: string;
}





/**
 * method for passing values
 */
const onInput = (value: string | null) => {
  emit('update:modelValue', value);
};

/**
 * method for change the value in the interface
 */
const onChange = (params: ChangeValueEventInterface) => {
  if (Array.isArray(props.options)) {
    onInput(params.value);
  } else {
    onInput(params.index);
  }
  emit('change', params);
};

const index: Ref<string | null> = ref(null);
const isSelectionListVisble = ref(false);

const store = useStore();
const isDesktop = computed(() => store.getters['platform/isDesktop']);
const isMobile = computed(() => store.getters['platform/isMobile']);
const isTablet = computed(() => store.getters['platform/isTablet']);

const getIndexByValue = (value: string | number): string | null => {
  if (Array.isArray(props.options)) {
    const index = props.options.findIndex(
      (v: string | number) => String(v) === String(value)
    );
    if (index >= 0) {
      return String(index);
    }
  } else {
    return String(value);
  }

  return null;
};

/**
 * to maintain the connectedness of the value by v-model, if the value changes there, then we automatically change it in the select
 */
watch(
  () => props.modelValue,
  () => {
    // console.debug('value must be', this.value, ' with index ', this.getIndexByValue(this.value), typeof this.value);
    // console.debug('options now is', JSON.stringify(this.options));
    if (props.modelValue) {
      index.value = getIndexByValue(props.modelValue);
    }
  },
  { immediate: true }
);

/**
 * method for shows a list of options
 */
const toggleList = () => {
  if (props.readonly) return;
  isSelectionListVisble.value = !isSelectionListVisble.value;
};

/**
 * method for closing after the selected item
 */
const hideList = () => {
  isSelectionListVisble.value = false;
};

const selectOptions = computed((): { [key: string]: string | number } => {
  if (Array.isArray(props.options)) {
    const parsedOptions: { [key: string]: string | number } = {};
    props.options.forEach((value: string | number, index: number) => {
      parsedOptions[String(index)] = value;
    });
    return parsedOptions;
  } else {
    return props.options;
  }
});

/**
 * getter for placeholder show or an empty string
 */
const placeholderValue = computed((): string => {
  return props.placeholder || '';
});

/**
 * getter for return index of selected option
 *
 * @returns selected optionindex number if exist
 * @returns null if no selected data
 *  */
const selectedOptionIndex = computed((): string | null => {
  // console.debug('index is >>>>>> ', this.index);
  if (index.value === null) {
    if (props.defaultIndex >= 0) {
      return String(props.defaultIndex);
    } else if (props.defaultValue) {
      return getIndexByValue(props.defaultValue);
    } else {
      return null;
    }
  } else {
    return String(index.value);
  }
});

/**
 * getter for return value of option
 *
 * @returns selected option if exist or selected
 * @returns empty string if not selected or not exist
 *  */
const selectedOptionValue = computed((): string => {
  if (
    selectedOptionIndex.value === null ||
    !selectOptions.value[selectedOptionIndex.value]
  ) {
    return '';
  } else {
    return String(selectOptions.value[selectedOptionIndex.value]);
  }
});

/**
 *  method for selection and close the list
 *
 * @param optionIndex - parameters for assigning a value
 */
const optionSelect = (optionIndex: any) => {
  index.value = optionIndex;
  hideList();
  onChange({
    index: selectedOptionIndex.value,
    value: selectedOptionValue.value,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        "data-name": "dropdown_name",
        class: _normalizeClass(["form-dropdown__name", {
          active: isSelectionListVisble.value,
          placeholderActive: !_unref(selectedOptionValue),
          errored: __props.isError,
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleList()))
      }, [
        _createTextVNode(_toDisplayString(_unref(selectedOptionValue) || _unref(placeholderValue)) + " ", 1),
        _hoisted_2
      ], 2),
      _createElementVNode("ul", {
        class: _normalizeClass(["form-dropdown__list", { selectShow: isSelectionListVisble.value }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: _normalizeClass(["form-dropdown__item", { selected: i == _unref(selectedOptionIndex) }]),
            onClick: ($event: any) => (optionSelect(i))
          }, _toDisplayString(option), 11, _hoisted_3))
        }), 128))
      ], 2)
    ], 512), [
      [_vShow, _unref(isDesktop)]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("select", {
        class: "select",
        value: _unref(selectedOptionIndex),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (optionSelect($event.target.value)))
      }, [
        _createElementVNode("option", _hoisted_5, _toDisplayString(_unref(placeholderValue)), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: i
          }, _toDisplayString(option), 9, _hoisted_6))
        }), 128))
      ], 40, _hoisted_4)
    ], 512), [
      [_vShow, _unref(isMobile) || _unref(isTablet)]
    ])
  ]))
}
}

})